import type { Types } from '@fiverr-private/theme';
import type { TabContextType, TabProps } from '../types';

export const getStylingProps = (
    variant: TabContextType['variant'],
    placement: TabContextType['placement'],
    isLink: TabProps['isLink'],
    isDisabled: TabProps['isDisabled'],
    isStretched: TabContextType['isStretched']
): Types.BoxType => ({
    borderWidth: 0,
    backgroundColor: 'transparent',
    fontSize: 'b_md',
    lineHeight: 'b_md',
    ...(variant === 'default' && {
        position: 'relative',
        borderStyle: 'solid',
        borderColor: 'grey_400',
        fontWeight: 'semibold',
        color: 'grey_800',
        whiteSpace: 'nowrap',
        userSelect: isDisabled ? 'none' : undefined,
        flex: isStretched ? '1' : undefined,
        ...(!isLink && { paddingY: '2' }),
        ...(placement === 'top' && {
            paddingX: isLink ? '0' : '8',
            textAlign: 'center',
            borderBottomWidth: 'sm',
        }),
        ...(placement === 'bottom' && {
            paddingX: isLink ? '0' : '8',
            textAlign: 'center',
            borderTopWidth: 'sm',
        }),
        ...(placement === 'left' && {
            paddingX: isLink ? '0' : '4',
            textAlign: 'end',
            borderRightWidth: 'sm',
        }),
        ...(placement === 'right' && {
            paddingX: isLink ? '0' : '4',
            textAlign: 'start',
            borderLeftWidth: 'sm',
        }),
    }),
});
